import { render } from "./TutorialPageTourInvitation.vue?vue&type=template&id=f1050254&scoped=true"
import script from "./TutorialPageTourInvitation.vue?vue&type=script&lang=js"
export * from "./TutorialPageTourInvitation.vue?vue&type=script&lang=js"

import "./TutorialPageTourInvitation.vue?vue&type=style&index=0&id=f1050254&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1050254"]])

export default __exports__